import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import QRCode from 'qrcode.react';
import { Header, BodyText, View } from 'modules/styled';

export default function LinkMobile() {
  // TODO we should use a crypto wallet instead
  const token = useSelector((state) => state.auth.token);
  return (
    <Fragment>
      <Header>Mobile Login</Header>
      <View
        sx={{
          p: 2,
          my: 4,
          mx: 'auto',
          alignSelf: 'center',
          variant: 'borders.navBorder',
          borderWidth: 1,
        }}
      >
        <QRCode value={token} />
      </View>
      <BodyText>
        Open the Relevant Mobile App, press "Link Desktop Account" and scan the QR code
      </BodyText>
    </Fragment>
  );
}
